import { BaseLayout } from '@layouts/BaseLayout';
import { Navbar } from '@components/volunteers/organisms/Navbar/Navbar';
import { Footer } from '@components/shared/organisms/Footer/Footer';

import styles from './VolunteerLayout.module.scss';

export function VolunteerLayout({
  children,
  showProfileDropdown = true,
}: {
  children: React.ReactNode;
  showProfileDropdown?: boolean;
}) {
  return (
    <BaseLayout>
      <div className={`${styles.volunteerLayout}`}>
        <Navbar showProfileDropdown={showProfileDropdown} />
        <main className={styles.main}>{children}</main>
        <Footer />
      </div>
    </BaseLayout>
  );
}
